<template>
  <div class="organizeManage">
    <el-row :gutter="10">
      <OACard header="组织架构" :col="8">
        <OATree
          ref="organize"
          :treeData="departData"
          node-key="id"
          @move-click="moveClick"
          @add-click="addClick"
          @edit-click="editClick"
          @remove-click="removeClick"
          @node-click="handleClick"
        ></OATree>
      </OACard>
      <postManage :depart-id="departId"></postManage>
    </el-row>
  </div>
</template>
<script>
import postManage from "./components/postManage";
import OACard from "@/components/OACard/OACard";
import OATree from "@/components/OATree/OATree";
import { Json2Tree, resFilter } from "@/common/util.js";
import commonApi from "@/services/common.js";
import organizeApi from "@/services/organize.js";

export default {
  name: "organizeManage",
  components: { postManage, OACard, OATree },
  data() {
    return {
      departData: [],
      departId: null
    };
  },
  mounted() {
    this.getDepart();
  },
  methods: {
    async getDepart() {
      let res = await commonApi.getDepart();
      this.departData = res.data.data;
    },
    handleClick(data) {
      this.departId = data.id;
    },
    async moveClick(data) {
      let res = await organizeApi.moveDepart(data);
      resFilter(res, this.getDepart());
    },
    async addClick(data) {
      let res = await organizeApi.addDepart(data);
      resFilter(res, this.getDepart());
    },
    async editClick(data) {
      let res = await organizeApi.editDepart(data);
      resFilter(res, this.getDepart());
    },
    async removeClick(data) {
      let res = await organizeApi.removeDepart(data);
      resFilter(res, this.getDepart());
    }
  }
};
</script>
<style lang="scss">
.organizeManage {
  .el-tree {
    min-height: 349px;
    .el-tree-node__content {
      line-height: 38px;
      height: 38px;
      &:hover {
        .tree-button {
          display: inline-block;
        }
      }
      .tree-button {
        position: absolute;
        right: 10px;
        display: none;
        .el-icon-sort {
          color: #67c23a;
          transform: rotate(90deg);
        }
        .el-icon-plus {
          color: #f7ae00;
        }
        .el-icon-edit {
          color: #1296db;
        }
        .el-icon-close {
          color: #ec2a33;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/personnel/organizeManage.vue